// Form: https://www.geeksforgeeks.org/how-to-perform-form-validation-in-react/
import React, { useState } from 'react';
import './../css/Form.css';
import {Params} from '../params.jsx'



function salutation(lang){
        switch (lang) {
            case 'ru':
            return(

                    {
                    mr : 'г-н',
                    ms : 'г-жа',
                    }
                    )
                    
                    case 'en':
            return(

                    {
                    mr : 'mr',
                    ms : 'ms',
                    }
                    )
                    
                    case 'en-br':
            return(

                    {   
                    mr : 'mr',
                    ms : 'ms',
                    } 
                    )  
                    

                    case 'de':
            return(

                    {
                    'mr' : 'herr',
                    'ms' : 'fr',
                    }
                    )
                    


                     case 'sr':
            return(

                    {
                    'mr' : 'г-н',
                    'ms' : 'г- ћа',
                    }
                    )
                    
                  
                  default:
            return(

                    {
                    'mr' : 'г-н',
                    'ms' : 'г-жа',
                    }
                    )
                    

        }
}

function MyForm(props) {
    const [formData, setFormData] = useState({
        salutation: salutation(props.lang).mr,
        name: '',
        phone: '',
        email: '',
        passport: ''

    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validateForm(formData);
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            // Form submission logic here
            props.onBook(formData)
        } else {
            console.log('Form submission failed due to validation errors.');
        }
    };

    const validateForm = (data) => {
        const errors = {};

        if (!data.name.trim()) {
            errors.name = 'Name is required';
        } else if (data.name.length < 4) {
            errors.name = 'Name must be at least 2 characters long';
        }

        if (!data.email.trim()) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(data.email)) {
            errors.email = 'Email is invalid';
        }

        if (!data.phone) {
            errors.phone = 'Phone is required';
        } else if (data.phone.length < 8) {
            errors.phone = 'Phone must be at least 8 characters long';
        }

        if (!data.passport) {
            errors.passport = 'passport is required';
        } else if (data.passport.length < 8) {
            errors.passport = 'passport must be at least 8 characters long';
        }


        return errors;
    };

    return (
        <div className="form-container">
            <h3 className="form-title">{Params(props.lang).person}</h3>
            <form onSubmit={handleSubmit}>
                <div>
                    <label className="fs-5">{Params(props.lang).salutation}</label>
                        <select
                        className="form-input"
                        name='salutation'
                        value={formData.salutation}
                        onChange={handleChange}
                        >
                          <option disabled>{Params(props.lang).salutation}</option>
                          <option value={salutation(props.lang).mr}>{salutation(props.lang).mr}</option>
                          <option value={salutation(props.lang).ms}>{salutation(props.lang).ms}</option>
                        </select>
                </div>
            
                <div>
                    <label className="form-label fs-5">
                        {Params(props.lang).name}:
                    </label>
                    <input
                        className="form-input"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {errors.name && (
                        <span className="error-message">
                            {errors.name}
                        </span>
                    )}
                </div>
                <div>
                    <label className="form-label fs-5">
                        {Params(props.lang).phone}:
                    </label>
                    <input
                        className="form-input"
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                    {errors.phone && (
                        <span className="error-message">
                            {errors.phone}
                        </span>
                    )}
                </div>
                <div>
                    <label className="form-label fs-5">
                        Email:
                    </label>
                    <input
                        className="form-input"
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && (
                        <span className="error-message">
                            {errors.email}
                        </span>
                    )}
                </div>
                <div>
                    <label className="form-label fs-5">
                        {Params(props.lang).passport}:
                    </label>
                    <input
                        className="form-input"
                        type="passport"
                        name="passport"
                        value={formData.passport}
                        onChange={handleChange}
                    />
                    {errors.passport && (
                        <span className="error-message">
                            {errors.passport}
                        </span>
                    )}
                </div>
                
                <button className="submit-button" type="submit">Submit</button>
            </form>
        </div>
    );
}

export default MyForm;
